export default __webpack_public_path__ + "static/equilibre_icon_board-a2851e49e586ce8cb805ea82355b5697.png";